module.exports = __webpack_public_path__ + "img/yw_ddsj.7ad372f2.svg";